import { FullscreenGallery } from './FullscreenGallery/FullscreenGallery';
import { sendEvent } from '../../helpers/analytics';
import isSupportsWebp from '../../helpers/isSupportsWebp';

class ConstructionGallery {
  constructor(parent, sourceData, houseId = 0) {
    this.parrent = parent;
    this.data = sourceData;
    this.house = houseId;
    this.album = 0;

    this.root = parent.querySelector('#construction-gallery');
    this.houseNodes = [...this.root.querySelectorAll('[data-house-albums]')];
    this.albumsNodes = [...this.root.querySelectorAll('[data-album]')];
    this.showAllButtons = [...this.root.querySelectorAll('[data-show-all]')];

    isSupportsWebp('lossy', (_, supportsWebp) => {
      this.isSupportsWebp = supportsWebp;
    });
    this.initFullscreenForAlbums();
    this.initShowAllButtons();
  }

  get currentHouseNode() {
    return this.root.querySelector(`[data-house-albums="${this.house}"]`);
  }

  initFullscreenForAlbums() {
    this.fullscreenGallery = new FullscreenGallery();

    this.albumsNodes.forEach((node) => {
      node.addEventListener('click', () => {
        const { house, album } = node.dataset;

        const images = this.data[house].albums[album].images;

        const pswSlides = images.map((details) => ({
          // dimensions are calculated dynamically
          w: 0,
          h: 0,
          src: `${details.large}${this.isSupportsWebp ? '.webp' : ''}`,
          date: details.date,
        }));

        this.fullscreenGallery.init({
          images: pswSlides,
          initialIndex: images.length - 1,
          house: this.data[house].albums[album].title,
          album: `Ракурс ${Number(album) + 1}`,
        });

        sendEvent(window.eventCategory, 'gallery', 'fullscreen_click');
      });
    });
  }

  initShowAllButtons() {
    this.showAllButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const showTextNode = button.querySelector('[data-button-show]');
        const hideTextNode = button.querySelector('[data-button-hide]');
        const currentAlbumsNodes = [...this.currentHouseNode.querySelectorAll(`[data-album]`)];
        const showAlbums = hideTextNode.classList.contains('hidden');

        if (!showAlbums) {
          this.parrent.scrollIntoView({
            block: 'start',
          });
        }

        this.currentHouseNode.style.setProperty('--rows', showAlbums ? Math.ceil(currentAlbumsNodes.length / 3) : 2);
        currentAlbumsNodes.forEach((album) => album.classList.toggle('-visible'));
        showTextNode.classList.toggle('hidden');
        hideTextNode.classList.toggle('hidden');
      });
    });
  }

  update(newHouseIndex) {
    this.house = Number(newHouseIndex);
    this.album = 0;

    this.updateHouse();
  }

  updateHouse() {
    this.houseNodes.forEach((node) => node.classList.add('hidden'));
    this.currentHouseNode.classList.remove('hidden');
  }
}

export default ConstructionGallery;
